import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    redirect() {
        window.location.href = this.element.value;
    }
}